/**
 * Grid + starburst scroll reveal. Observes every `.grid-rules` overlay
 * (rendered by snippets/grid-section.liquid) and adds `.in-view` once it's
 * ~15% visible, which the CSS in theme.css uses to animate the rules/stars
 * drawing in. Respects prefers-reduced-motion by skipping straight to the
 * final state with no observer/animation at all.
 *
 * Other section/asset files (header scroll-shrink, cart drawer, lightbox,
 * countdown, etc.) own their own init logic and should not be merged in here.
 */
function initGridReveal() {
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const gridSections = document.querySelectorAll('.grid-rules');

  if (prefersReducedMotion) {
    gridSections.forEach((el) => el.classList.add('in-view'));
    return;
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('in-view');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15 }
  );

  gridSections.forEach((el) => observer.observe(el));
}

document.addEventListener('DOMContentLoaded', initGridReveal);

/**
 * Product/about media carousel (prev/next/dots). Lives here instead of in
 * sections/product-purchase.liquid or sections/about-retail.liquid's own
 * {% javascript %} blocks: those two sections had byte-identical carousel
 * code, and Shopify's theme compiler deduplicates identical section JS
 * blocks into a single instance gated behind only ONE of the section types
 * (__sections__["about-retail"]) — so on pages with product-purchase but not
 * about-retail (e.g. the Shop page), that code silently never ran. Global
 * theme.js has no per-section gating, so it works on every page unconditionally.
 */
function initProductCarousels() {
  document.querySelectorAll('[data-product-carousel]').forEach(function (carousel) {
    var track = carousel.querySelector('.about-carousel__track, .product-carousel__track');
    var slides = carousel.querySelectorAll('[data-carousel-slide]');
    var dots = carousel.querySelectorAll('[data-carousel-dot]');
    var prevBtn = carousel.querySelector('[data-carousel-prev]');
    var nextBtn = carousel.querySelector('[data-carousel-next]');
    if (!track || !slides.length) return;

    var index = 0;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function goTo(i) {
      index = (i + slides.length) % slides.length;
      track.style.transition = reduceMotion ? 'none' : 'transform 0.4s ease';
      track.style.transform = 'translateX(-' + index * 100 + '%)';
      dots.forEach(function (dot, di) {
        dot.classList.toggle('is-active', di === index);
      });
    }

    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(index - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(index + 1); });
    dots.forEach(function (dot, di) {
      dot.addEventListener('click', function () { goTo(di); });
    });
  });
}

document.addEventListener('DOMContentLoaded', initProductCarousels);
